var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-back",on:{"mouseup":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)},"touchend":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }